import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, CardContent } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  GridActionsCellItem,
  GridRowParams,
  GridValueGetterParams,
} from "@mui/x-data-grid";

import { Card, Breadcrumbs, BaseDataGrid } from "components/ui";
import { Header } from "components/layouts";
import { useDeleteUser, useUsers } from "lib/hooks";
import { User } from "lib/types";
import { ConfirmDialog } from "components/common";

const route = "/admin/users";
const title = "Пользователи";
const List = () => {
  const navigate = useNavigate();
  const [page, setPage] = useState<number>();
  const { isLoading, data, refetch } = useUsers(page);
  const mutation = useDeleteUser();
  const [deleteId, setDeleteId] = useState<number | null>(null);

  const deleteRecord = () => {
    deleteId &&
      mutation.mutate(deleteId, {
        onSuccess: () => {
          refetch();
        },
      });
  };

  const handleSetDeleteId = (id: number) => {
    setDeleteId(id);
  };

  const handleCancel = () => {
    setDeleteId(null);
  };

  const handleDelete = async () => {
    await deleteRecord();
    handleCancel();
  };

  const columns = [
    {
      field: "userName",
      flex: 1,
      headerName: "Имя пользователя",
      sortable: false,
    },
    {
      field: "role",
      flex: 1,
      headerName: "Роль",
      sortable: false,
      valueGetter: ({ value }: GridValueGetterParams) => {
        return value?.name ?? "-";
      },
    },
    {
      field: "id",
      type: "actions",
      getActions: (params: GridRowParams<User>) => {
        return [
          <GridActionsCellItem
            label="Удалить"
            onClick={() => handleSetDeleteId(params.row.id)}
            icon={<DeleteIcon />}
          />,
        ];
      },
    },
  ];

  const hanleChangePage = (page: number) => {
    setPage(page);
  };

  return (
    <>
      <ConfirmDialog
        isLoading={mutation.isLoading}
        open={Boolean(deleteId)}
        onCancel={handleCancel}
        onSubmit={handleDelete}
      />
      <Header
        title={title}
        right={
          <Button onClick={() => navigate(`${route}/new`)}>Создать</Button>
        }
      />
      <Breadcrumbs crumbs={[{ label: "Главная", to: "/" }, { label: title }]} />
      <Card>
        <CardContent>
          <BaseDataGrid
            style={{ height: "calc(100vh - 235px)" }}
            loading={isLoading}
            columns={columns}
            rows={data?.data}
            page={page}
            hanleChangePage={hanleChangePage}
            rowCount={data?.totalCount}
            onRowClick={({ row }: any) => {
              navigate(`${route}/${row.id}`);
            }}
          />
        </CardContent>
      </Card>
    </>
  );
};
export default List;
